// Where to send the user after a successful login. The home page (or any gated
// entry point) stashes the intended destination under "postLoginRedirect" before
// opening the login dialog; login completion calls this to consume it. Falls back
// to /dashboard. Only same-origin, absolute-path routes are honored so a stale or
// tampered value can't turn login into an open redirect.
export function postLoginRedirect(fallback: string = "/dashboard"): string {
    const target = sessionStorage.getItem("postLoginRedirect");
    sessionStorage.removeItem("postLoginRedirect");
    if (target && target.startsWith("/") && !target.startsWith("//")) {
        return target;
    }
    return fallback;
}
